import styled from 'styled-components';

import theme from '../../constants/theme';

export const TabContainer = styled.div`
  display: flex;
  position: sticky;
  top: 0;
  z-index: ${Styles.zIndex.normal};
  background-color: ${theme.tabBackground};
  padding-bottom: 1rem;
  ${Styles.desktop`
    top: 0px;
    padding: 0 1rem 0.5rem;
    margin: 0;
  `}
`;

// used to smooth over transition into new, flagged slim-store-cards components
// cleanup when ENABLE_MAP_VIEW_MOBILE_VERTICAL_SCROLL_AND_SLIM_STORE_CARDS is removed
export const Padding = styled.div`
  z-index: ${Styles.zIndex.top};
  padding: 1.5rem 1rem 0;
  position: relative;
`;

export const SearchContainer = styled.div`
  order: 2;
  width: 100%;
  height: 45%;
  overflow: scroll;

  ${Styles.desktop`
    order: 1;
    width: 23rem;
    height: 100%;
    overflow: scroll;
  `}
`;
